import { UID, getColumns } from "./common";

export default {
  columns: getColumns({
    header: "Analytics",
    subheader:
      "See funnel analytics and other metrics for each of your payment links."
  }),
  rows: [
    {
      title: {
        value: "Conversion funnels",
        tooltip: "See how many people are completing checkout for each link."
      },
      stripe: {
        uid: UID.STRIPE,
        enabled: false
      },
      priceblocs: {
        uid: UID.PRICEBLOCS,
        enabled: true
      }
    },
    {
      title: {
        value: "Dashboards",
        tooltip: "See the overall metrics for each payment link."
      },
      stripe: {
        uid: UID.STRIPE,
        enabled: false
      },
      priceblocs: {
        uid: UID.PRICEBLOCS,
        enabled: true
      }
    }
  ]
};
